'use client'

import { Card, CardContent } from '@/components/ui/card'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { ImageWithFallback as Image } from '@/components/common/image-with-fallback'
import { useTranslations } from 'next-intl'

export const InfoPanel = () => {
  const t = useTranslations('page_avery_dennision_factory.info')

  const infoItems = [
    { label: t('company_name_label'), value: t('company_name') },
    { label: t('address_label'), value: t('address') },
    { label: t('scale_label'), value: t('scale') },
    { label: t('capacity_label'), value: t('capacity') },
  ]

  return (
    <Card className='h-full rounded-3xl border-none bg-[linear-gradient(212.5deg,#1A1A1A,#333333)] text-white shadow-lg'>
      <CardContent className='relative p-6 md:px-10 md:py-10 2xl:py-20'>
        <div className='relative z-10'>
          {infoItems.map((item, index) => (
            <div key={index} className={index !== 0 ? 'mt-6' : ''}>
              <p className='text-base text-white md:text-lg'>{item.label}</p>
              <p className='mt-1 font-criteria text-lg font-bold md:text-xl 2xl:text-2xl'>
                {item.value}
              </p>
            </div>
          ))}
        </div>
        <div className='absolute bottom-0 left-0 z-0'>
          <Image
            src={ImageHelper.getImageUrl('/image/August2025/mceclip7_98.png')}
            alt='Avery Dennison Factory'
            width={350}
            height={50}
            className='h-auto object-contain opacity-50'
          />
        </div>
      </CardContent>
    </Card>
  )
}
